import { Component } from 'react';

import { injectIntl } from 'react-intl';
import type { IntlShape } from 'react-intl';
// eslint-disable-next-line import/no-extraneous-dependencies
import { BuildStatus } from 'src/components/types';

import CheckCircleIcon from '@atlaskit/icon/core/check-circle';
import StatusWorkflowDangerIcon from '@atlaskit/icon-lab/core/status-workflow-danger';
import StatusWorkflowInProgressIcon from '@atlaskit/icon-lab/core/status-workflow-in-progress';
import StatusWorkflowStoppedIcon from '@atlaskit/icon-lab/core/status-workflow-stopped';
import { token } from '@atlaskit/tokens';
import { RelativeDate } from '@atlassian/bitkit-date';

import messages from '../../i18n';
import * as styles from '../../styles';

type BuildProps = {
  build: BuildStatus;
  intl: IntlShape;
  routerPush?: (pathname: string) => void;
};

const BUILD_STATUS_ICON_LABELS = new Map([
  ['SUCCESSFUL', messages.successfulStatusIcon],
  ['STOPPED', messages.stoppedStatusIcon],
  ['FAILED', messages.failedStatusIcon],
  ['INPROGRESS', messages.inProgressStatusIcon],
]);

class BuildComponent extends Component<BuildProps> {
  getStatusIcon = (buildState: string) => {
    const message = BUILD_STATUS_ICON_LABELS.get(buildState);
    let label = '';

    if (message) {
      label = this.props.intl.formatMessage(message);
    }

    switch (buildState) {
      case 'SUCCESSFUL':
        return (
          <CheckCircleIcon
            spacing="spacious"
            label={label}
            color={token('color.icon.success')}
          />
        );
      case 'STOPPED':
        return (
          <StatusWorkflowStoppedIcon
            spacing="spacious"
            label={label}
            color={token('color.icon.subtle')}
          />
        );
      case 'FAILED':
        return (
          <StatusWorkflowDangerIcon
            spacing="spacious"
            label={label}
            color={token('color.icon.danger')}
          />
        );
      case 'INPROGRESS':
        return (
          <StatusWorkflowInProgressIcon
            spacing="spacious"
            label={label}
            color={token('color.icon.information')}
          />
        );
      default:
        return null;
    }
  };

  render() {
    const { build, routerPush } = this.props;
    const buildName = build.name || build.key;

    return (
      <styles.BuildItem>
        <styles.BuildState>{this.getStatusIcon(build.state)}</styles.BuildState>
        <styles.BuildInfo>
          <styles.BuildName title={buildName}>
            {build.url ? (
              <a
                href={build.url}
                onClick={e => {
                  if (routerPush && !(e.metaKey || e.ctrlKey)) {
                    e.preventDefault();
                    routerPush(build.url);
                  }
                }}
              >
                {buildName}
              </a>
            ) : (
              buildName
            )}
          </styles.BuildName>
          <styles.BuildDetails>
            <styles.BuildDescription title={build.description}>
              {build.description}
            </styles.BuildDescription>
            <styles.BuildTime>
              <RelativeDate date={build.updated_on} />
            </styles.BuildTime>
          </styles.BuildDetails>
        </styles.BuildInfo>
      </styles.BuildItem>
    );
  }
}

export const Build = injectIntl(BuildComponent);
